import TableLoader from './TableLoader';

export default function ExpandedRow({ loading, noItemsKey }) {
  const className = loading ? 'expanded-row' : 'expanded-row table-empty';
  return (
    <div className={className}>{loading ? <TableLoader /> : noItemsKey}</div>
  );
}
